import React from 'react';
import PropTypes from 'prop-types';
import ProductCardList from '../ProductCardList';
import Product from './Product';
import Filter from '../ProductList/Filter';
import './ProductListII.scss';

const ProductListII = props => (
  <section className="product-card-list">
    {props.addFiltering && (
      <Filter
        filter={props.filter}
        filterOptions={props.filterOptions}
        itemsVisible={props.visibleProducts}
        values={props.values}
        errors={props.errors}
        onHandleChange={props.handleChange}
      />
    )}
    <div className="container-guttered product-list-ii">
      <ProductCardList 
        items={props.items}
        component={Product}
        ageRangeLabel={props.ageRangeLabel}
      />
    </div>
  </section>
);

ProductListII.propTypes = {
  ageRangeLabel: PropTypes.string.isRequired,
  addFiltering: PropTypes.bool,
  filter: PropTypes.object,
  filterOptions: PropTypes.arrayOf(PropTypes.object),
  values: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  visibleProducts: PropTypes.number,
  items: PropTypes.array.isRequired
};

export default ProductListII;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductListII/ProductListII.js